export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FeaturedPeopleListing.vue?vue&type=template&id=4e7cc72a&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/FeaturedPeopleListing.vue?vue&type=template&id=4e7cc72a&scoped=true
// module id = 209
// module chunks = 0